<section id="hotels-informations" class="section">
    <div class="container is-fullhd">
        <div class="columns">
            <div class="column is-10">
                <h1>
                    Hotéis
                    <span><button class="button is-rounded" (click)="goToHotels()">Todos os hotéis</button></span>
                </h1>
                <p>
                    Hotéis, pousadas, resorts, hotéis fazenda… Não importa o tipo de acomodação, as
                    melhores opções estão aqui aguardando por você.
                </p>
            </div>
            <div id="button">
                <button class="button is-rounded" (click)="goToHotels()">Todos os hotéis</button>
            </div>
        </div>

        <div id="highlights">
            <div class="columns" *ngIf="highlightsList && highlightsList.length > 0">
                <div class="column" *ngFor="let item of highlightsList.slice(0,2)">
                    <div class="item-hotel" *ngIf="item">
                        <div class="bg-hotel" [style.backgroundImage]="'url('+ item.images[0] +')'" [attr.aria-label]="item.alt" [style.backgroundSize]="'cover'"></div>
                        <div class="overlay-img"></div>
                        <a (click)="navigateToHotelDetails(item.contractCode, item.slug)">
                            <div class="description-hotel">
                                <p class="h3-title">{{item.name}}</p>
                                <p>{{item.city}},{{item.state}}</p>
                            </div>
                        </a>
                    </div>
                </div>

            </div>
        </div>


        <div id="premium">
            <div class="columns" *ngIf="premiumList && premiumList.length > 0">
                <div class="column" *ngFor="let item of premiumList.slice(0,3)">
                    <div class="item-hotel" *ngIf="item">
                        <div class="bg-hotel" [style.backgroundImage]="'url('+ item.images[0] +')'" [attr.aria-label]="item.alt"></div>
                        <div class="overlay-img"></div>
                        <a (click)="navigateToHotelDetails(item.contractCode, item.slug)">
                            <div class="description-hotel">
                                <p class="h3-title">{{item.name}}</p>
                                <p>{{item.city}}, {{item.state}}</p>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div id="new">
            <div class="columns" *ngIf="newList && newList.length > 0">
                <div class="column" *ngFor="let item of newList.slice(0,3)">
                    <div class="item-hotel medium-hotel"  *ngIf="item">
                        <div class="bg-hotel" [style.backgroundImage]="'url('+ item.images[0] +')'" [attr.aria-label]="item.alt"></div>
                        <div class="overlay-img"></div>
                        <a (click)="navigateToHotelDetails(item.contractCode, item.slug)">
                            <div class="description-hotel">
                                <p class="h3-title">{{item.name}}</p>
                                <p>{{item.city}}, {{item.state}}</p>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
